import { render, staticRenderFns } from "./NotiCardItemIcon.vue?vue&type=template&id=36c72a23&"
import script from "./NotiCardItemIcon.vue?vue&type=script&lang=js&"
export * from "./NotiCardItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports